import { APIScope, RoleInterface, RoleInterfaceMap } from "@swivl-mono/types";
import { Button, ButtonVariant, LayoutWithSidebar, Spinner } from "@swivl-mono/ui";
import _ from "lodash";
import { useParams } from "react-router-dom";

import { ShowIf } from "../../../Components/ShowIf/ShowIf";
import { SidebarLink } from "../../../Components/SidebarLink/SidebarLink";
import { Member } from "../../../Models/Member/Member.Current";
import ModalModel from "../../../Models/Modal/Modal.Model";
import RolesModel from "../../../Models/Roles/Roles.Model";
import { CreateNewRoleModal } from "./Modal/CreateNewRole.Modal";
import { RoleSettingsDetailsView } from "./Role.Settings.Details.View";

function RolesListWithHeading(props: { roles: RoleInterfaceMap; heading: string }) {
  const { roles, heading } = props;
  return (
    <div className="mb-3 flex flex-col">
      <label className="ml-3">{heading}</label>
      {Object.values(roles).map((role: RoleInterface) => {
        {
          return (
            <SidebarLink to={"/settings/roles/" + role.slug} key={role.slug} height={38}>
              {role.name}
            </SidebarLink>
          );
        }
      })}
    </div>
  );
}

export function RolesSettingsView() {
  const { roles, defaultRoles, parentRoles } = RolesModel.useState();
  const params = useParams();
  const roleSlug = params.roleSlug;
  let role: RoleInterface | undefined = undefined;
  if (roleSlug) {
    role = defaultRoles?.[roleSlug] ?? roles?.[roleSlug] ?? parentRoles?.[roleSlug];
  }

  return (
    <LayoutWithSidebar
      sidebar={
        <div className="mt-5 flex flex-col">
          {roles ? (
            <>
              {defaultRoles && !_.isEmpty(defaultRoles) && <RolesListWithHeading roles={defaultRoles} heading="Default Roles" />}
              {parentRoles && !_.isEmpty(parentRoles) && <RolesListWithHeading roles={parentRoles} heading="Inherited Roles" />}
              {roles && !_.isEmpty(roles) && <RolesListWithHeading roles={roles} heading={Member.isInParentOrg ? "Roles" : "Custom Roles"} />}
              <ShowIf scope={APIScope.ROLES_SET}>
                <Button
                  className="m-2"
                  variant={ButtonVariant.DASHED}
                  onClick={() => {
                    ModalModel.showModalWithContent(<h2>Create New Role</h2>, <CreateNewRoleModal />);
                  }}
                >
                  Create New Role
                </Button>
              </ShowIf>
            </>
          ) : (
            <div className="align-center flex justify-center">
              <Spinner />{" "}
            </div>
          )}
        </div>
      }
      content={<div>{role ? <RoleSettingsDetailsView key={role.slug} role={role} /> : null}</div>}
    />
  );
}
